module.exports = __webpack_public_path__ + "img/chevron-left.39568443.svg";